import { useEffect, useState } from 'react';
import { getNetworkStatus, listenForNetworkChanges } from '../services/native/networkService.js';

export function useIsOnline() {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' || navigator.onLine !== false,
  );
  useEffect(() => {
    let active = true;
    void getNetworkStatus().then((status) => {
      if (active) setOnline(status.connected);
    });
    const remove = listenForNetworkChanges((status) => setOnline(status.connected));
    return () => {
      active = false;
      remove();
    };
  }, []);
  return online;
}
